import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import ClientRegister from '../views/ClientRegister.vue'
import ExistingClient from '../views/ExistingClient.vue'
import ShipManpower from '../views/ShipManpower.vue'
import ShipPicture from '../views/ShipPicture.vue'
import EditShip from '../views/EditShip.vue'
import MyShipPricingLog from '../views/MyShipPricingLog/MyShipPricingLog.vue'
import MySingleShipPricingLog from '../views/MyShipPricingLog/MySingleShipPricingLog.vue'
import MyShipPriceUpdate from '../views/MyShipPricingLog/MyShipPriceUpdate.vue'
import MySales from '../views/MySales.vue'
import CreateSale from '../views/CreateSale.vue'
import AllSales from '../views/AllSales.vue'
import MyInstallationRequisitions from '../views/MyInstallationRequisitions.vue'
import MyInstallationAssignments from '../views/MyInstallationAssignments.vue'
import ServiceRequisitions from '../views/ServiceRequisitions.vue'
import MyServiceAssignments from '../views/MyServiceAssignments.vue'
import CreateServiceRequisition from '../views/CreateServiceRequisition.vue'
import AssignGpsDevice from '../views/AssignGpsDevice.vue'
import PickGpsDeviceFromShip from '../views/PickGpsDeviceFromShip.vue'
import ShipLastPosition from '../views/ShipLastPosition.vue'
import NewGpsDevice from '../views/NewGpsDevice.vue'
import MyGpsDevice from '../views/MyGpsDevice.vue'
import GpsDeviceTransfer from '../views/GpsDeviceTransfer.vue'
import MySentGpsDeviceTransferRequest from '../views/MySentGpsDeviceTransferRequest.vue';
import MyReceivedGpsDeviceTransferRequest from '../views/MyReceivedGpsDeviceTransferRequest.vue';
import Drafts from '../views/Drafts.vue';
import RequestIOU from '../views/RequestIOU.vue';
import MyReceivedIOURequests from '../views/MyReceivedIOURequests.vue';
import MySentIOURequests from '../views/MySentIOURequests.vue';
import BillSubmit from '../views/BillSubmit.vue';
import MyBills from '../views/MyBills.vue';
import ReceivedBillRequests from '../views/ReceivedBillRequests.vue';
import CreateBoat from '../views/CreateBoat.vue';
import CreateGhat from '../views/CreateGhat.vue';
import RequestIouBack from '../views/IouBack/RequestIouBack.vue';
import MySentIOUBackRequests from '../views/IouBack/MySentIOUBackRequests.vue';
import MyReceivedIOUBackRequests from '../views/IouBack/MyReceivedIOUBackRequests.vue';
import BillDiscountApplicationList from '../views/BillDiscountApplication/BillDiscountApplicationList.vue';
import Attendance from '../views/hr/Attendance.vue';
import LeaveApply from '../views/hr/LeaveApply.vue';
import MyLeaves from '../views/hr/MyLeaves.vue';
import LeaveApprovals from '../views/hr/LeaveApprovals.vue';
import FieldVisitsVerify from '../views/hr/FieldVisitsVerify.vue';
import AttendanceReport from '../views/hr/AttendanceReport.vue';
import TeamDaily from '../views/hr/TeamDaily.vue';
import ManualAttendanceApply from '../views/hr/ManualAttendanceApply.vue';
import ManualAttendanceApprovals from '../views/hr/ManualAttendanceApprovals.vue';
import RecallLeave from '../views/hr/RecallLeave.vue';
import SalesLeads from '../views/sales-leads/SalesLeads.vue';
import SalesLeadForm from '../views/sales-leads/SalesLeadForm.vue';
import SalesLeadDetail from '../views/sales-leads/SalesLeadDetail.vue';
import SalesLeadMeeting from '../views/sales-leads/SalesLeadMeeting.vue';
import SalesLeadMeetings from '../views/sales-leads/SalesLeadMeetings.vue';
import SalesLeadTransfers from '../views/sales-leads/SalesLeadTransfers.vue';
import HelpCenter from '../views/help/HelpCenter.vue';
import HelpDoc from '../views/help/HelpDoc.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '',
    redirect: '/login'
  },
  {
    path: '/login',
    component: () => import ('../views/Login.vue')
  },
  {
    path: '/home',
    component: () => import ('../views/Home.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/client-register/:sale_id/:draftId?',
    component: ClientRegister,
    props:true,
    meta: { requiresAuth: true }
  },
  {
    path: '/existing-client/:sale_id/:draftId?',
    component: ExistingClient,
    props:true,
    meta: { requiresAuth: true }
  },
  {
    path: '/ship-manpower',
    component: ShipManpower,
    meta: { requiresAuth: true }
  },
  {
    path: '/edit-ship',
    component: EditShip,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-ship-pricing-log/:segment?/:logId?',
    props: true,
    component: MyShipPricingLog,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-ship-price-update/:shipId?',
    component: MyShipPriceUpdate,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-single-ship-pricing-log/:shipId?',
    component: MySingleShipPricingLog,
    meta: { requiresAuth: true }
  },
  {
    path: '/ship-picture',
    component: ShipPicture,
    meta: { requiresAuth: true }
  },
  {
    path: '/create-sale',
    component: CreateSale,
    meta: { requiresAuth: true }
  },
  {
    path: '/all-sales/:segment?/:saleId?',
    component: AllSales,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-sales',
    component: MySales,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-installation-requisitions',
    component: MyInstallationRequisitions,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-installation-assignments',
    component: MyInstallationAssignments,
    meta: { requiresAuth: true }
  },
  {
    path: '/create-service-requisition',
    component: CreateServiceRequisition,
    meta: { requiresAuth: true }
  },
  {
    path: '/service-requisitions',
    component: ServiceRequisitions,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-service-assignments',
    component: MyServiceAssignments,
    meta: { requiresAuth: true }
  },
  {
    path: '/assign-gps-device',
    component: AssignGpsDevice,
    meta: { requiresAuth: true }
  },
  {
    path: '/pick-gps-device-from-ship',
    component: PickGpsDeviceFromShip,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-gps-device',
    component: MyGpsDevice,
    meta: { requiresAuth: true }
  },
  {
    path: '/new-gps-device',
    component: NewGpsDevice,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-sent-gps-device-transfer-request',
    component: MySentGpsDeviceTransferRequest,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-received-gps-device-transfer-request',
    component: MyReceivedGpsDeviceTransferRequest,
    meta: { requiresAuth: true }
  },
  {
    path: '/ship-last-position',
    component: ShipLastPosition,
    meta: { requiresAuth: true }
  },
  {
    path: '/gps-device-transfer/:serials',
    component: GpsDeviceTransfer,
    props:true,
    meta: { requiresAuth: true }
  },
  {
    path: '/drafts',
    component: Drafts,
    meta: { requiresAuth: true }
  },
  {
    path: '/request-iou',
    component: RequestIOU,
    meta: { requiresAuth: true }
  },
  {
    path: '/request-iou-back',
    component: RequestIouBack,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-sent-iou-back-requests',
    component: MySentIOUBackRequests,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-received-iou-back-requests',
    component: MyReceivedIOUBackRequests,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-received-iou-requests',
    component: MyReceivedIOURequests,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-sent-iou-requests',
    component: MySentIOURequests,
    meta: { requiresAuth: true }
  },
  {
    path: '/bill-submit',
    component: BillSubmit,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-bills',
    component: MyBills,
    meta: { requiresAuth: true }
  },
  {
    path: '/received-bill-requests/:billId?',
    component: ReceivedBillRequests,
    props:true,
    meta: { requiresAuth: true }
  },
  {
    path: '/create-boat',
    component: CreateBoat,
    props:true,
    meta: { requiresAuth: true }
  },
  {
    path: '/create-ghat',
    component: CreateGhat,
    props:true,
    meta: { requiresAuth: true }
  },
  {
    path: '/bill-discount-application/:segment?/:applicationId?',
    component: BillDiscountApplicationList,
    props:true,
    meta: { requiresAuth: true }
  },
  {
    path: '/hr/attendance',
    component: Attendance,
    meta: { requiresAuth: true }
  },
  {
    path: '/hr/leave-apply',
    component: LeaveApply,
    meta: { requiresAuth: true }
  },
  {
    path: '/hr/my-leaves',
    component: MyLeaves,
    meta: { requiresAuth: true }
  },
  {
    path: '/hr/leave-approvals',
    component: LeaveApprovals,
    meta: { requiresAuth: true }
  },
  {
    path: '/hr/field-visits-verify',
    component: FieldVisitsVerify,
    meta: { requiresAuth: true }
  },
  {
    path: '/hr/attendance-report',
    component: AttendanceReport,
    meta: { requiresAuth: true }
  },
  {
    path: '/hr/team-daily',
    component: TeamDaily,
    meta: { requiresAuth: true }
  },
  {
    path: '/hr/manual-attendance-apply',
    component: ManualAttendanceApply,
    meta: { requiresAuth: true }
  },
  {
    path: '/hr/manual-attendance-approvals',
    component: ManualAttendanceApprovals,
    meta: { requiresAuth: true }
  },
  {
    path: '/hr/recall-leave',
    component: RecallLeave,
    meta: { requiresAuth: true }
  },
  // Sales Lead Tracking. These paths are also push-notification deep links
  // (SalesLeadService::APP_*_PATH on the server) and doc links (config/docs.php).
  {
    path: '/sales-leads',
    component: SalesLeads,
    meta: { requiresAuth: true }
  },
  {
    path: '/sales-leads/:leadId',
    component: SalesLeadDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/sales-lead-form/:leadId?',
    component: SalesLeadForm,
    meta: { requiresAuth: true }
  },
  {
    path: '/sales-lead-meetings',
    component: SalesLeadMeetings,
    meta: { requiresAuth: true }
  },
  {
    path: '/sales-lead-meeting/:meetingId',
    component: SalesLeadMeeting,
    meta: { requiresAuth: true }
  },
  {
    path: '/sales-lead-transfers',
    component: SalesLeadTransfers,
    meta: { requiresAuth: true }
  },
  {
    path: '/help',
    component: HelpCenter,
    meta: { requiresAuth: true }
  },
  {
    path: '/help/:slug',
    component: HelpDoc,
    meta: { requiresAuth: true }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
